(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HOVER_OPEN_DELAY = 80;
    var HOVER_CLOSE_DELAY = 140;

    function init(header) {
      if (header.__skInit) return;
      header.__skInit = true;

      var items = header.querySelectorAll('[data-sk-item]');
      var drawer = header.querySelector('[data-sk-drawer]');
      var burger = header.querySelector('[data-sk-burger]');
      var closeBtn = header.querySelector('[data-sk-close]');
      var scrim = header.querySelector('[data-sk-scrim]');
      var openTimer, closeTimer;
      var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

      function closeAll() {
        items.forEach(function (item) {
          item.classList.remove('is-open');
          var t = item.querySelector('[data-sk-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        header.classList.remove('is-open');
      }

      function open(item) {
        closeAll();
        item.classList.add('is-open');
        var t = item.querySelector('[data-sk-trigger]');
        if (t) t.setAttribute('aria-expanded', 'true');
        header.classList.add('is-open');
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-sk-trigger]');

        item.addEventListener('mouseenter', function () {
          if (!canHover.matches) return;
          clearTimeout(closeTimer);
          openTimer = setTimeout(function () { open(item); }, HOVER_OPEN_DELAY);
        });
        item.addEventListener('mouseleave', function () {
          if (!canHover.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(closeAll, HOVER_CLOSE_DELAY);
        });

        // Keyboard: Enter/Space toggles, Esc closes. Mouse click still follows the link.
        trigger.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') {
            if (!item.classList.contains('is-open')) {
              e.preventDefault();
              open(item);
            }
          }
          if (e.key === 'Escape') { closeAll(); trigger.focus(); }
        });

        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            if (!header.querySelector('.is-open')) header.classList.remove('is-open');
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); closeDrawer(); }
      });

      // Mobile drawer
      function openDrawer() {
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      }
      function closeDrawer() {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 250);
      }
      if (burger) burger.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

      // Language and country / currency selectors: submit as soon as a choice is made
      header.querySelectorAll('[data-sk-loc]').forEach(function (sel) {
        sel.addEventListener('change', function () { sel.form.submit(); });
      });

      // Turn the transparent overlay header solid after scrolling
      var collapseAnn = header.classList.contains('sk-header--collapse-ann');
      function onScroll() {
        var y = window.scrollY;
        header.classList.toggle('is-scrolled', y > 10);
        if (collapseAnn) {
          if (y > 80) header.classList.add('is-ann-hidden');
          else if (y < 10) header.classList.remove('is-ann-hidden');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      // Theme editor: close menus when the section is re-rendered or deselected
      document.addEventListener('shopify:section:unload', closeAll);
      document.addEventListener('shopify:section:deselect', closeAll);
    }

    function boot() {
      document.querySelectorAll('[data-sk-header]').forEach(init);
    }
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__sbcInit) return;
      root.__sbcInit = true;

      var track = root.querySelector('[data-sbc-track]');
      var prev = root.querySelector('[data-sbc-prev]');
      var next = root.querySelector('[data-sbc-next]');
      if (!track) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        root.classList.toggle('is-static', max <= 1);
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= max - 1;
      }

      function scrollByPage(dir) {
        var item = track.querySelector('.sbc__item');
        var step = item ? item.getBoundingClientRect().width : track.clientWidth * 0.5;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var visible = Math.max(1, Math.floor(track.clientWidth / (step + gap)));
        track.scrollBy({ left: dir * (step + gap) * visible, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { scrollByPage(1); });

      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();

      // Theme editor: bring a selected block into view
      root.closest('[data-sbc-section]').addEventListener('shopify:block:select', function (e) {
        e.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    }

    function boot() {
      document.querySelectorAll('[data-sbc]').forEach(init);
    }
    boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
